var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.applePayAvailable)?_c('div',{staticClass:"apple-pay-button apple-pay-button-black",on:{"click":_vm.onClickHandler}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }